import RoutesMap from '../../../route_control/RouteControl'
import { Form, InputGroup, Card, Button } from 'react-bootstrap'
import { useFormik } from 'formik'
import { LoginSchema, ForgetPasswordSchema } from './ValidationSchema'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { LuKeyRound, LuUser2 } from 'react-icons/lu'
import Logo from '../../../assets/images/rexomovers_blue.png'
import { ButtonLoader } from '../../loader'
import { SessionManager } from '../../../utils'
import { signInTodo, sidebarTodo } from '../../../redux/slices/assets'

export const LoginFormImport = {
    RoutesMap,
    Form,
    InputGroup,
    Card,
    Button,
    useFormik,
    LoginSchema,
    ForgetPasswordSchema,
    useNavigate,
    useDispatch,
    toast,
    LuKeyRound,
    LuUser2,
    Logo,
    ButtonLoader,
    SessionManager,
    signInTodo,
    sidebarTodo,
}